module.exports = __webpack_public_path__ + "img/head-banner3.8d5270a0.png";